import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const menuSlice = createSlice({
  initialState: {
    collapsed: undefined as boolean,
  },
  name: 'menu',
  reducers: {
    toggle: (state, action: PayloadAction<boolean>) => {
      return {
        collapsed: action.payload,
      }
    },
  },
})


export const { toggle } = menuSlice.actions
